// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import toast from "react-hot-toast";
// import productService from "../../Services/productService";
// import WarningAmberIcon from "@mui/icons-material/WarningAmber";
// import Stack from "@mui/material/Stack";
// import Pagination from "@mui/material/Pagination";

// const Stock = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isOpen, setIsOpen] = useState();

//   useEffect(() => {
//     const getMedicines = async () => {
//       try {
//         setLoading(true);
//         const response = await productService.fetchMedicines();
//         console.log(response);
//         setRecords(response.products);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Patients");
//       }
//     };
//     getMedicines();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       records?.filter((item) =>
//         item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase()),
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, records]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleAddProduct = (data) => {
//     productService.create(data).then((res) => {});
//   };

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Stock</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-full border-collapse rounded-lg overflow-hidden">
//             <thead>
//               <tr className="bg-gray-700 text-white text-xs capitalize leading-normal text-left">
//                 <th className="p-4 w-[10%]">Sr No.</th>
//                 <th className="p-4 w-[20%]">Medicine Name</th>
//                 <th className="p-4 w-[15%]">Item Code</th>
//                 <th className="p-4 w-[15%]">Qty</th>
//                 <th className="p-4 w-[15%]">Sale Price</th>
//                 <th className="p-4 w-[15%]">Discount Price</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient, index) => (
//                 <tr
//                   key={patient?.id}
//                   className="bg-white text-xs border-t border-gray-200"
//                 >
//                   <td className="p-4 w-[10%] font-bold text-primary">
//                     {patient?.stock_id}
//                   </td>
//                   <td className="p-4 w-[20%] font-bold">
//                     {patient?.medicine_name}
//                   </td>
//                   <td className="p-4 w-[15%]">{patient?.item_code}</td>
//                   <td className="p-4 w-[15%] flex items-center gap-2">
//                     {patient?.quantity}
//                     {patient?.quantity < 4 && (
//                       <WarningAmberIcon
//                         className="text-red-500"
//                         titleAccess="Low Stock"
//                       />
//                     )}
//                   </td>
//                   <td className="p-4 w-[15%] font-semibold">
//                     {patient.sale_price}
//                   </td>
//                   <td className="p-4 w-[15%] font-semibold">
//                     {parseFloat(
//                       patient.sale_price - patient.discount_price,
//                     ).toFixed(2)}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="flex justify-center my-4">
//           <Stack spacing={2}>
//             <Pagination
//               count={Math.ceil(filteredData.length / itemsPerPage)}
//               page={currentPage}
//               onChange={handlePageChange}
//               variant="outlined"
//               shape="rounded"
//             />
//           </Stack>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Stock;

import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import productService from "../../Services/productService";

const Stock = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getMedicines = async () => {
      try {
        setLoading(true);
        const response = await productService.fetchMedicines();
        setRecords(response.products);
      } catch (error) {
        toast.error("Error fetching Stock");
      } finally {
        setLoading(false);
      }
    };
    getMedicines();
  }, []);

  useEffect(() => {
    const result =
      records?.filter((item) =>
        item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase()),
      ) || [];
    setFilteredData(result);
  }, [searchData, records]);

  const colWidths = ["70px", "180px", "130px", "100px", "120px", "130px"];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Stock
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            {filteredData.length || 0} records found
          </p>
        </div>
      </div>

      <div className="relative mb-4">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search by medicine name..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="w-full sm:w-72 pl-9 pr-4 py-3 text-xs border border-gray-200 rounded-lg bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-100"
        />
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No stock found
          </div>
        ) : (
          filteredData.map((item, index) => (
            <div
              key={item?.id}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                  {item?.medicine_name?.charAt(0) || "M"}
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-gray-800">
                    {item?.medicine_name}
                  </p>
                  <p className="text-[10px] text-gray-400">#{item?.stock_id}</p>
                </div>
                {item?.quantity < 4 && (
                  <span className="ml-auto inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 text-red-600">
                    Low Stock
                  </span>
                )}
              </div>
              <div className="divide-y divide-gray-100">
                {[
                  { label: "Item Code", value: item?.item_code },
                  { label: "Qty", value: item?.quantity },
                  { label: "Sale Price", value: `Rs.${item?.sale_price}` },
                  {
                    label: "After Disc.",
                    value: `Rs.${parseFloat(item.sale_price - item.discount_price).toFixed(2)}`,
                  },
                ].map(({ label, value }) => (
                  <div key={label} className="flex justify-between py-1.5">
                    <span className="text-[11px] text-gray-400 w-20">
                      {label}
                    </span>
                    <span className="text-[11px] text-gray-700 text-right">
                      {value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Sr No.",
                  "Medicine Name",
                  "Item Code",
                  "Qty",
                  "Sale Price",
                  "Disc. Price",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${i < 5 ? "border-r border-white/10" : ""}`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No stock found
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr
                    key={item?.id}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${index % 2 ? "bg-gray-50" : "bg-white"}`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-semibold text-gray-500 border-r border-gray-100">
                      {item?.stock_id}
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        {/* <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0">
                          {item?.medicine_name?.charAt(0) || "M"}
                        </div> */}
                        <span className="text-[12px] font-medium text-gray-800 truncate">
                          {item?.medicine_name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {item?.item_code}
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        <span className="text-[12px] text-gray-600">
                          {item?.quantity}
                        </span>
                        {item?.quantity < 4 && (
                          <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium bg-red-100 text-red-600">
                            Low
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      Rs.{item?.sale_price}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600">
                      Rs.
                      {parseFloat(
                        item.sale_price - item.discount_price,
                      ).toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={6}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-t border-white/10"
                >
                  {filteredData.length || 0} total records
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Stock;
